<script>
  import { onMount } from "svelte";
  import { fade } from "svelte/transition";

  export let tile;

  let isVisible = false;
  let isSmallScreen = false;
  let randomId = Math.floor(Math.random() * (1200 - 1 + 1)) + 1;
  let hasTableSection = tile.tableSection;

  window.addEventListener("resize", function() {
    setTileSpecs(window.innerWidth);
  });

  onMount(() => {
    setTileSpecs(window.innerWidth);
    let contenTileElement = document.querySelector(`#content-tile-${randomId}`);
  });

  function setTileSpecs(windowWidth) {
    if (windowWidth < 700) {
      textWidth = "100%";
      elWidth = "100%";
    }
    if (windowWidth > 700 && windowWidth < 1200 && !isSmallScreen) {
      elWidth = widthMapMobile[tile.contentTileSize].elWidth;
      textWidth = widthMapMobile[tile.contentTileSize].textWidth;
      isSmallScreen = true;
    }
    if (windowWidth > 1200) {
      elWidth = widthMap[tile.contentTileSize].elWidth;
      textWidth = widthMap[tile.contentTileSize].textWidth;
      isSmallScreen = false;
    }
  }

  let widthMap = {
    "col-1": { elWidth: "25%", textWidth: "100%" },
    "col-2": { elWidth: "50%", textWidth: "100%" },
    "col-3": { elWidth: "75%", textWidth: "100%" },
    "col-4": { elWidth: "100%", textWidth: "100%" }
  };
  let widthMapMobile = {
    "col-1": { elWidth: "50%", textWidth: "100%" },
    "col-2": { elWidth: "50%", textWidth: "100%" },
    "col-3": { elWidth: "100%", textWidth: "50%" },
    "col-4": { elWidth: "100%", textWidth: "50%" }
  };

  let elWidth = widthMap[tile.contentTileSize].elWidth;
  let textWidth = widthMap[tile.contentTileSize].textWidth;
  let markedCopy = marked.marked(tile.contentTileCopy);
</script>

<style>
  .wrapper {
    position: relative;
  }
  .content-wrapper {
    padding: 0 20px 20px 20px;
  }
  .content-tile-image-wrapper {
    padding-top: 20px;
    min-height: 20vw;
    background-size: cover;
    background-position: center;
    width: 100%;
    max-width: 100%;
    height: auto;
  }
  .table-entry {
    margin-bottom: 24px;
  }
  .table-entry-header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid black;
    margin-bottom: 14px;
    font-weight: 600;
  }
  @media (max-width: 700px) {
    .table-entry {
      font-size: 18px;
    }
    .content-tile-image-wrapper {
      min-height: 40vh;
    }
    .content-wrapper {
      padding: 0;
    }
  }
  .content-tile-copy {
    font-family: adapterRegular;
    font-size: 22px;
    line-height: 1.3;
    font-weight: 400;
  }
  p {
    font-size: 20px;
    line-height: 1.4;
  }
  h3 {
    font-size: 28px;
    text-transform: uppercase;
  }
  img {
    max-width: 100%;
  }
  .col-1 {
    width: 25%;
  }
  .col-2 {
    width: 100%;
  }
  .col-3 {
    width: 75%;
  }
  .col-4 {
    width: 100%;
  }
</style>

<div class="wrapper" style="width: {elWidth}" id={`content-tile-${randomId}`}>
  <div class="content-wrapper">
    {#if tile.contentTileImage}
      <div
        class="content-tile-image-wrapper"
        style="background-image: url({tile.contentTileImage})" />
    {/if}
    {#if tile.contentTileCopy}
      <div class="content-tile-copy markdown" style="width: {textWidth}">
        {@html markedCopy}
      </div>
    {/if}
    {#if hasTableSection}
      <div class="content-tile-copy">
       {#each tile.tableSection as entry}
        <div class="table-entry">
          <div class="table-entry-header">
            <span>{entry.date}</span>
            <span>{entry.location}</span>
          </div>
          <div>{entry.description}</div>
        </div>
        {/each}
      </div>
    {/if}
  </div>
</div>
